// import React, { useState, useEffect, useRef } from "react";
// import DashNavbar from "./DashNavbar";
// import Sidebar from "./Sidebar";
// import Swal from "sweetalert2";
// import "../css/dash.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FcApproval, FcCancel } from "react-icons/fc";
// import { FaEye } from "react-icons/fa";
// import { IoWarningOutline } from "react-icons/io5";
// import axios from "axios";

// function DocumentUpload() {
//   const [files, setFiles] = useState([]);
//   const [fileNames, setFileNames] = useState({
//     aadhar: "",
//     pan: "",
//     hsc: "",
//     ssc: "",
//     degree: "",
//     other: "",
//   });
//   const [selectedFileNames, setSelectedFileNames] = useState({
//     aadhar: "",
//     pan: "",
//     hsc: "",
//     ssc: "",
//     degree: "",
//     other: "",
//   });
//   const [filePaths, setFilePaths] = useState({
//     aadhar: "",
//     pan: "",
//     hsc: "",
//     ssc: "",
//     degree: "",
//     other: "",
//   });
//   const [statuses, setStatuses] = useState({
//     aadhar: null,
//     pan: null,
//     hsc: null,
//     ssc: null,
//     degree: null,
//     other: null,
//   });
//   const [username, setUsername] = useState("");
//   const [email, setEmail] = useState("");

//   const aadharInputRef = useRef(null);
//   const panInputRef = useRef(null);
//   const hscInputRef = useRef(null);
//   const sscInputRef = useRef(null);
//   const degreeInputRef = useRef(null);
//   const otherInputRef = useRef(null);

//   useEffect(() => {
//     const storedUsername = localStorage.getItem("UserName");
//     const storedEmail = localStorage.getItem("email");
//     setUsername(storedUsername || "");
//     setEmail(storedEmail || "");
//     fetchDocuments(storedEmail);
//   }, []);

//   const fetchDocuments = async (email) => {
//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/document_user_status?email=${email}`
//       );
//       const document = response.data[0];
//       setFileNames({
//         aadhar: document.aadhar?.split("/").pop() || "",
//         pan: document.pan?.split("/").pop() || "",
//         hsc: document.hsc?.split("/").pop() || "",
//         ssc: document.ssc?.split("/").pop() || "",
//         degree: document.degree?.split("/").pop() || "",
//         other: document.other?.split("/").pop() || "",
//       });
//       setFilePaths({
//         aadhar: document.aadhar || "",
//         pan: document.pan || "",
//         hsc: document.hsc || "",
//         ssc: document.ssc || "",
//         degree: document.degree || "",
//         other: document.other || "",
//       });
//       setStatuses({
//         aadhar: document.aadhar_status,
//         pan: document.pan_status,
//         hsc: document.hsc_status,
//         ssc: document.ssc_status,
//         degree: document.degree_status,
//         other: document.other_status,
//       });
//     } catch (error) {
//       console.error("Error fetching documents:", error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, files: newFiles } = e.target;
//     const fileName = newFiles[0]?.name || "";

//     setFiles((prevFiles) => [...prevFiles, { name, file: newFiles[0] }]);
//     setFileNames((prevNames) => ({ ...prevNames, [name]: fileName }));
//     setSelectedFileNames((prevSelectedFileNames) => ({
//       ...prevSelectedFileNames,
//       [name]: fileName,
//     }));
//   };

//   const viewDocument = async (email, documentType) => {
//     try {
//       const response = await fetch("https://raasbackend.vetrinahealthcare.com/api/view_document/", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, document_type: documentType }),
//       });

//       if (response.ok) {
//         const blob = await response.blob();
//         const url = window.URL.createObjectURL(blob);
//         window.open(url);
//       } else {
//         const error = await response.json();
//         console.error("Error viewing document:", error.error);
//       }
//     } catch (error) {
//       console.error("Error viewing document:", error);
//     }
//   };

//   const handleDocumentClick = (email, documentType) => {
//     viewDocument(email, documentType);
//   };

//   const handleButtonClick = (inputRef) => {
//     inputRef.current.click();
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("username", username);
//     formData.append("email", email);
//     files.forEach((file) => {
//       formData.append(file.name, file.file);
//     });

//     try {
//       const response = await fetch(
//         "https://raasbackend.vetrinahealthcare.com/api/document_upload/",
//         {
//           method: "POST",
//           body: formData,
//         }
//       );

//       if (response.ok) {
//         Swal.fire({
//           icon: "success",
//           title: "Upload Successful",
//           text: "Your documents have been uploaded successfully!",
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         });
//         fetchDocuments(email); // Refresh document statuses
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Upload Failed",
//           text: "Oops! Something went wrong. Please try again later.",
//           timer: 1000,
//           timerProgressBar: true,
//           showConfirmButton: false,
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "An error occurred while uploading. Please try again later.",
//         timer: 1000,
//         timerProgressBar: true,
//         showConfirmButton: false,
//       });
//     }
//   };

//   const iconStyle = { fontSize: "1.5em" };

//   return (
//     <>
//       <DashNavbar />
//       <div className="wrapper">
//         <Sidebar />
//         <div className="col-lg-10 col-md-8 col-sm-12 main dash4">
//           <div className="container mt-4">
//             <div className="text-start">
//               <h3>Upload/Edit Documents</h3>
//               <p>Fill in the details below to upload/edit documents:</p>
//             </div>
//             <div className="auth-inner mt-5 w-100">
//               <form onSubmit={handleSubmit} className="upload-form">
//                 <div className="table-responsive">
//                   <table className="table">
//                     <thead>
//                       <tr>
//                         <th>Document Name</th>
//                         <th>Choose File</th>
//                         <th>Selected File</th>
//                         <th>Verification Status</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {[
//                         {
//                           label: "Aadhar Card",
//                           name: "aadhar",
//                           ref: aadharInputRef,

//                         },
//                         { label: "PAN Card", name: "pan", ref: panInputRef },
//                         {
//                           label: "HSC Mark Sheet",
//                           name: "hsc",
//                           ref: hscInputRef,
//                         },
//                         {
//                           label: "SSC Mark Sheet",
//                           name: "ssc",
//                           ref: sscInputRef,
//                         },
//                         {
//                           label: "Degree/Mark Sheet",
//                           name: "degree",
//                           ref: degreeInputRef,
//                         },
//                         {
//                           label: "Other Document (In 1 PDF)",
//                           name: "other",
//                           ref: otherInputRef,
//                         },
//                       ].map((doc) => (
//                         <tr key={doc.name}>
//                           <td className="text-start">{doc.label}</td>
//                           <td>
//                             <button
//                               type="button"
//                               className="btn btn-outline-primary"
//                               onClick={() => handleButtonClick(doc.ref)}
//                             >
//                               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
//                                 <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125" stroke="#fffffff" stroke-width="2"></path>
//                                 <path d="M17 15V18M17 21V18M17 18H14M17 18H20" stroke="#fffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
//                               </svg>
//                               Upload File
//                             </button>

//                             <input
//                               type="file"
//                               className="form-control"
//                               id={doc.name}
//                               name={doc.name}
//                               ref={doc.ref}
//                               required
//                               onChange={handleChange}
//                               style={{ display: "none" }}
//                               accept=".pdf"
//                             />
//                           </td>
//                           <td>
//                             {filePaths[doc.name] ? (
//                               <div className="d-flex justify-content-center">
//                                 <a
//                                   href="#"
//                                   onClick={(e) => {
//                                     e.preventDefault();
//                                     handleDocumentClick(email, doc.name);
//                                   }}
//                                 >
//                                   {fileNames[doc.name]}
//                                 </a>
//                                 <FaEye
//                                   className="ms-2"
//                                   onClick={() => handleDocumentClick(email, doc.name)}
//                                   style={{ cursor: 'pointer' }}
//                                 />
//                               </div>

//                             ) : selectedFileNames[doc.name] ? (
//                               <span>{selectedFileNames[doc.name]}</span>
//                             ) : (
//                               <small className="text-muted">
//                                 No file selected
//                               </small>
//                             )}
//                           </td>
//                           <td>
//                             {statuses[doc.name] === "Y" && (
//                               <FcApproval style={iconStyle} />
//                             )}
//                             {statuses[doc.name] === "N" && (
//                               <FcCancel style={iconStyle} />
//                             )}
//                             {statuses[doc.name] === null && (
//                               <IoWarningOutline style={iconStyle} />
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>

//                 <footer className="footer py-3 bg-light mt-2">
//                   <button type="submit" className="btn btn-primary">
//                     Submit Document
//                   </button>
//                 </footer>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default DocumentUpload;


import React, { useState, useEffect, useRef } from "react";
import DashNavbar from "./DashNavbar";
import Sidebar from "./Sidebar";
import Swal from "sweetalert2";
import "../css/dash.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { FcApproval, FcCancel } from "react-icons/fc";
import { FaEye } from "react-icons/fa";
import { IoWarningOutline } from "react-icons/io5";
import axios from "axios";

function DocumentUpload() {
  const [files, setFiles] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [fileNames, setFileNames] = useState({
    aadhar: "",
    pan: "",
    hsc: "",
    ssc: "",
    degree: "",
    passport_photo: "",
    driving_licence: "",
    cheque_photo: "",
    experience_letter: "",
    other: "",
  });
  const [selectedFileNames, setSelectedFileNames] = useState({
    aadhar: "",
    pan: "",
    hsc: "",
    ssc: "",
    degree: "",
    passport_photo: "",
    driving_licence: "",
    cheque_photo: "",
    experience_letter: "",
    other: "",
  });
  const [filePaths, setFilePaths] = useState({
    aadhar: "",
    pan: "",
    hsc: "",
    ssc: "",
    degree: "",
    passport_photo: "",
    driving_licence: "",
    cheque_photo: "",
    experience_letter: "",
    other: "",
  });
  const [statuses, setStatuses] = useState({
    aadhar: null,
    pan: null,
    hsc: null,
    ssc: null,
    degree: null,
    passport_photo: null,
    driving_licence: null,
    cheque_photo: null,
    experience_letter: null,
    other: null,
  });
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");

  const aadharInputRef = useRef(null);
  const panInputRef = useRef(null);
  const hscInputRef = useRef(null);
  const sscInputRef = useRef(null);
  const degreeInputRef = useRef(null);
  const passportPhotoInputRef = useRef(null);
  const drivingLicenceInputRef = useRef(null);
  const chequePhotoInputRef = useRef(null);
  const experienceLetterInputRef = useRef(null);
  const otherInputRef = useRef(null);

  // Configuration for document fields
  const documentFieldsConfig = [
    { label: "Aadhar Card", name: "aadhar", ref: aadharInputRef },
    { label: "PAN Card", name: "pan", ref: panInputRef },
    { label: "HSC Mark Sheet", name: "hsc", ref: hscInputRef },
    { label: "SSC Mark Sheet", name: "ssc", ref: sscInputRef },
    { label: "UG Certificate/Mark Sheet", name: "degree", ref: degreeInputRef },
    { label: "PG Certificate/Mark Sheet", name: "other", ref: otherInputRef },
    { label: "Passport Size Photo", name: "passport_photo", ref: passportPhotoInputRef },
    { label: "Driving Licence", name: "driving_licence", ref: drivingLicenceInputRef },
    { label: "Photo of Cheque", name: "cheque_photo", ref: chequePhotoInputRef },
    { label: "Experience Letter", name: "experience_letter", ref: experienceLetterInputRef },
  ];


  useEffect(() => {
    const storedUsername = localStorage.getItem("UserName");
    const storedEmail = localStorage.getItem("email");
    setUsername(storedUsername || "");
    setEmail(storedEmail || "");
    if (storedEmail) {
        fetchDocuments(storedEmail);
    }
  }, []);

  const fetchDocuments = async (userEmail) => {
    if (!userEmail) return;
    try {
      const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/document_user_status/?email=${userEmail}`);
      if (response.data && response.data.length > 0) {
        const document = response.data[0];
        
        const newFileNames = {};
        const newFilePaths = {};
        const newStatuses = {};

        documentFieldsConfig.forEach(field => {
            newFileNames[field.name] = document[field.name]?.split("/").pop() || "";
            newFilePaths[field.name] = document[field.name] || "";
            newStatuses[field.name] = document[`${field.name}_status`];
        });

        setFileNames(newFileNames);
        setFilePaths(newFilePaths);
        setStatuses(newStatuses);

      } else {
        console.log("No document record found for this user yet.");
         const initialStates = {};
         documentFieldsConfig.forEach(field => {
            initialStates[field.name] = ""; 
         });
         setFileNames({...initialStates}); 
         setFilePaths({...initialStates});
         setStatuses(documentFieldsConfig.reduce((acc, field) => {
            acc[field.name] = null;
            return acc;
        }, {}));
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  const handleChange = (e) => {
    const { name, files: newFiles } = e.target;
    const fileName = newFiles[0]?.name || "";

    setFiles((prevFiles) => ({ ...prevFiles, [name]: newFiles[0] }));
    setSelectedFileNames((prevSelectedFileNames) => ({
      ...prevSelectedFileNames,
      [name]: fileName,
    }));
    setFileNames((prevNames) => ({ ...prevNames, [name]: fileName }));
  };

  const viewDocument = async (userEmail, documentType) => {
    try {
      const response = await fetch("https://raasbackend.vetrinahealthcare.com/api/view_document/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: userEmail, document_type: documentType }),
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const contentType = response.headers.get("content-type");
        let fileType = "application/octet-stream"; 
        if (contentType && contentType.includes("application/pdf")) {
            fileType = "application/pdf";
        } else if (contentType && contentType.startsWith("image/")) {
            fileType = contentType;
        }
        
        const file = new Blob([blob], { type: fileType });
        const url = window.URL.createObjectURL(file);
        window.open(url, "_blank"); 
        window.URL.revokeObjectURL(url); 
      } else {
        const error = await response.json();
        Swal.fire({
            icon: "error",
            title: "View Failed",
            text: error.error || "Could not load document.",
        });
        console.error("Error viewing document:", error.error);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "View Error",
        text: "An error occurred while trying to view the document.",
      });
      console.error("Error viewing document:", error);
    }
  };

  const handleDocumentClick = (userEmail, documentType) => {
    viewDocument(userEmail, documentType);
  };

  const handleButtonClick = (inputRef) => {
    if (inputRef.current) {
        inputRef.current.click();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredDocuments = Object.keys(statuses)
      .filter(docName => statuses[docName] === "N");
    const missingDocuments = requiredDocuments.filter(docName => !files[docName]);

    if (missingDocuments.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Documents",
        text: `Please re-upload the following rejected documents: ${missingDocuments.map(doc => documentFieldsConfig.find(f => f.name === doc)?.label || doc).join(", ")}`,
      });
      return;
    }
    
    if (Object.keys(files).length === 0) {
        Swal.fire({
            icon: "info",
            title: "No Files Selected",
            text: "Please select at least one file to upload.",
        });
        return;
    }

    const formData = new FormData();
    formData.append("username", username);
    formData.append("email", email);

    for (const name in files) {
      if (files.hasOwnProperty(name) && files[name]) { 
        formData.append(name, files[name]);
      }
    }

    setIsLoading(true);

    try {
      const response = await fetch("https://raasbackend.vetrinahealthcare.com/api/document_upload/",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Upload Successful",
          text: "Your documents have been uploaded successfully!",
          timer: 1500, 
          timerProgressBar: true,
          showConfirmButton: false,
        });
        setFiles({}); 
        setSelectedFileNames(documentFieldsConfig.reduce((acc, field) => { 
            acc[field.name] = "";
            return acc;
        }, {}));
        fetchDocuments(email); 
      } else {
        const errorData = await response.json().catch(() => ({detail: "Upload failed. Please check details."}));
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: errorData.detail || errorData.error || "Oops! Something went wrong. Please try again later.",
          timer: 2000,
          timerProgressBar: true,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while uploading. Please try again later.",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const iconStyle = { fontSize: "1.5em", verticalAlign: "middle" };

  const getButtonClassName = (status) => {
    let baseClass = "btn same-size-button d-flex align-items-center justify-content-center"; 

    if (status === "Y") {
      baseClass += " btn-success";
    } else if (status === "N") {
      baseClass += " btn-danger"; // No need for ms-0 here if we use inline style
    } else {
      baseClass += " btn-outline-primary";
    }
    return baseClass;
  };

  return (
    <>
      <DashNavbar />
      <div className="wrapper">
        <Sidebar />
        <div className="col-lg-10 col-md-8 col-sm-12 main dash4">
          <div className="container mt-4">
            <div className="text-start mb-4">
              <h3>Upload/Edit Documents</h3>
              <p className="text-muted">Fill in the details below to upload or edit your documents. Accepted file type: PDF only.</p>
            </div>
            <div className="auth-inner mt-3 w-100" style={{padding: "20px"}}>
              <form onSubmit={handleSubmit} className="upload-form">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th style={{width: "25%"}}>Document Name</th>
                        <th style={{width: "25%"}} className="text-center">Choose File</th>
                        <th style={{width: "30%"}} className="text-center">Selected/Uploaded File</th>
                        <th style={{width: "20%"}} className="text-center">Verification Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentFieldsConfig.map((doc) => (
                        <tr key={doc.name}>
                          <td className="text-start align-middle fw-medium">{doc.label}</td>
                          <td className="button-cell text-center align-middle">
                            <button
                              type="button"
                              className={getButtonClassName(statuses[doc.name])}
                              onClick={() => handleButtonClick(doc.ref)}
                              disabled={statuses[doc.name] === "Y"}
                              style={{
                                minWidth: "150px",
                                // Conditionally apply marginLeft: 0px ONLY for rejected button
                                ...(statuses[doc.name] === "N" && { marginLeft: "0px" }) 
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                aria-hidden="true"
                                width="20"
                                height="20"
                                className="me-2"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125"
                                  stroke={statuses[doc.name] === "Y" || statuses[doc.name] === "N" ? "#ffffff" : "#0d6efd"}
                                ></path>
                                <path
                                  d="M17 15V18M17 21V18M17 18H14M17 18H20"
                                  stroke={statuses[doc.name] === "Y" || statuses[doc.name] === "N" ? "#ffffff" : "#0d6efd"}
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                              {statuses[doc.name] === "Y"
                                ? "Approved"
                                : statuses[doc.name] === "N" 
                                ? "Re-upload"
                                : "Upload File"}
                            </button>

                            <input
                              type="file"
                              className="form-control"
                              id={doc.name}
                              name={doc.name}
                              ref={doc.ref}
                              onChange={handleChange}
                              style={{ display: "none" }}
                              accept=".pdf" 
                              disabled={statuses[doc.name] === "Y"}
                            />
                          </td>
                          <td className="text-center align-middle">
                            {filePaths[doc.name] ? ( 
                              <div className="d-flex align-items-center justify-content-center">
                                <a
                                  href="#"
                                  className="text-decoration-none"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDocumentClick(email, doc.name);
                                  }}
                                  title={`View ${fileNames[doc.name] || 'document'}`}
                                >
                                  {fileNames[doc.name] || "View Uploaded File"}
                                </a>
                                <FaEye
                                  className="ms-2 text-primary"
                                  onClick={() =>
                                    handleDocumentClick(email, doc.name)
                                  }
                                  style={{ cursor: "pointer", fontSize: "1.2em" }}
                                  title="View file"
                                />
                              </div>
                            ) : selectedFileNames[doc.name] ? ( 
                              <span className="text-muted fst-italic">{selectedFileNames[doc.name]}</span>
                            ) : (
                              <small className="text-muted">
                                No file selected
                              </small>
                            )}
                          </td>
                          <td className="text-center align-middle">
                            {statuses[doc.name] === "Y" && (
                              <FcApproval style={iconStyle} title="Approved" />
                            )}
                            {statuses[doc.name] === "N" && (
                              <FcCancel style={iconStyle} title="Rejected" />
                            )}
                            {(statuses[doc.name] === null || statuses[doc.name] === undefined) && (
                              <IoWarningOutline style={{...iconStyle, color: "#ffc107"}} title="Pending" />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <footer className="footer py-3 mt-3 border-top">
                  <div className="container text-center">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg px-5"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        "Submit Documents"
                      )}
                    </button>
                  </div>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DocumentUpload;